//# sourceMappingURL=my-date-range.interface.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/mydatepicker/dist/interfaces/my-date-range.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-date-range.interface.js
// module chunks = 4